import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import ProductsTable from "../../../components/Product/All-products"

const Products = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Products | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <ProductsTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default Products
